import { useState, useEffect, useCallback } from 'react'
import { ShoppingCart, X } from 'lucide-react'
import { useCart } from '@store/cart/CartProvider'

const INTERVAL_MS = 2 * 60 * 1000

export function CartReminder() {
  const { count, isOpen, setOpen } = useCart()
  const [visible, setVisible] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  const show = useCallback(() => {
    if (count > 0 && !isOpen) {
      setVisible(true)
      setDismissed(false)
    }
  }, [count, isOpen])

  useEffect(() => {
    if (count === 0) {
      setVisible(false)
      setDismissed(false)
      return
    }

    show()

    const timer = setInterval(show, INTERVAL_MS)
    return () => clearInterval(timer)
  }, [count, show])

  const handleDismiss = () => {
    setVisible(false)
    setDismissed(true)
  }

  const handleOpenCart = () => {
    setVisible(false)
    setOpen(true)
  }

  if (!visible || dismissed || isOpen) return null

  return (
    <div className="fixed top-4 right-4 z-[90] animate-in slide-in-from-top-2 fade-in duration-300">
      <div className="flex items-start gap-3 rounded-lg border border-orange-200 bg-white p-4 shadow-lg max-w-[340px]">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-orange-100">
          <ShoppingCart className="h-5 w-5 text-orange-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-gray-800">Cesta de Transfer pendiente</p>
          <p className="text-xs text-gray-500 mt-0.5">
            Tienes {count} producto{count !== 1 ? 's' : ''} pendiente{count !== 1 ? 's' : ''} de confirmar.
          </p>
          <button
            onClick={handleOpenCart}
            className="mt-2 text-xs font-medium text-orange-600 hover:text-orange-700 underline underline-offset-2"
          >
            Ver cesta
          </button>
        </div>
        <button
          onClick={handleDismiss}
          className="shrink-0 rounded-md p-1 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
